exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-1f9e8373]{object-fit:cover;width:100%;height:27vh}.posts-box__top--auto-hight[data-v-1f9e8373]{height:70px}.category-line[data-v-1f9e8373]{opacity:.3;margin:0}.ad-728-90-above[data-v-1f9e8373]{margin-top:-20px;margin-bottom:20px;text-align:center}.ad-728-90-below[data-v-1f9e8373]{margin-top:20px;margin-bottom:20px;text-align:center}.ad-300-250-sidebar-above[data-v-1f9e8373]{text-align:center;margin-bottom:40px}.ad-300-250-sidebar-below[data-v-1f9e8373]{text-align:center;margin-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f9e8373","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/News.vue
// module id = 154
// module chunks = 0